var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00104 8C6.21837 8 6.42237 7.894 6.54704 7.71533L11.2137 1.04867C11.3564 0.845333 11.3724 0.579333 11.259 0.358667C11.1437 0.138 10.9164 0 10.6677 0H1.33304C1.08437 0 0.857036 0.138 0.741703 0.358667C0.628369 0.579333 0.644369 0.845333 0.787036 1.04867L5.4537 7.71533C5.57837 7.894 5.78237 8 5.9997 8H6.00104Z",
    fill: "#3DA64F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownGreenIcon);
export default __webpack_public_path__ + "static/media/down_green_icon.12067dbd0ea8725d59a8e069cd5757e6.svg";
export { ForwardRef as ReactComponent };